module.exports = __webpack_public_path__ + "static/media/logo-orange-blue.a1145539.jpg";